"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterprisePaymentType = exports.EnterpriseKind = void 0;
/**
 * Temporary type that describes if the legacy enterprise was an enterprise or organization.
 * We converted/merged enterprises and organizations, but for some few parts of the platform we still needed
 * to have this differentiation until other features were implemented. This type holds that information
 */
var EnterpriseKind;
(function (EnterpriseKind) {
    EnterpriseKind["enterprise"] = "enterprise";
    EnterpriseKind["organization"] = "organization";
})(EnterpriseKind || (exports.EnterpriseKind = EnterpriseKind = {}));
var EnterprisePaymentType;
(function (EnterprisePaymentType) {
    EnterprisePaymentType["MANUAL"] = "manual_payments";
    /**
     * Users won't see the PM selector, instead we will assume a 'customer_balance' Stripe Payment method
     * type at creation
     */
    EnterprisePaymentType["BANK_TRANSFER"] = "bank_transfer";
})(EnterprisePaymentType || (exports.EnterprisePaymentType = EnterprisePaymentType = {}));
//# sourceMappingURL=Enterprises.js.map